import React from "react";
import { Users, Phone, Mail, Calendar } from "lucide-react";

export default function RecentClients({ clients = [], loading = false }) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };

  if (loading) {
    return (
      <div className="card">
        <h3>Recent Clients</h3>
        <div className="loading-text">Loading clients...</div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="card-header">
        <h3>Recent Clients</h3>
        <span className="badge">{clients.length} total</span>
      </div>
      
      {clients.length === 0 ? (
        <div className="empty-state">
          <Users size={48} />
          <p>No clients found</p>
        </div>
      ) : (
        <div className="recent-list">
          {clients.slice(0, 5).map(client => (
            <div key={client._id} className="recent-item">
              <div className="avatar">
                {client.fullName?.charAt(0) || "C"}
              </div>
              <div className="item-info">
                <div className="item-main">
                  <span className="item-title">{client.fullName || "Unnamed Client"}</span>
                  <span className={`status-badge status-${client.status?.toLowerCase() || 'new'}`}>
                    {client.status || "New"}
                  </span>
                </div>
                <div className="item-details">
                  {client.email && (
                    <span className="item-detail">
                      <Mail size={12} />
                      {client.email}
                    </span>
                  )}
                  {client.phone && (
                    <span className="item-detail">
                      <Phone size={12} />
                      {client.phone}
                    </span>
                  )}
                  {client.createdAt && (
                    <span className="item-detail">
                      <Calendar size={12} />
                      {formatDate(client.createdAt)}
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      
      {clients.length > 5 && (
        <div className="card-footer">
          <a href="/clients" className="view-all">
            View all clients →
          </a>
        </div>
      )}
    </div>
  );
}